import { MediaRoom, MediaUserRole } from '@/services/liveMedia.service';
import { UserRole } from '@/services/user.service';

export type AgoraObserverRole = 'host' | 'recorder';

export type AgoraObserverStore = {
  rootState: { route?: { query?: Record<string, unknown> } };
  rootGetters: { [k: string]: any };
};

export function getAgoraObserverRole(
  room: Pick<MediaRoom, 'userRole'> | null | undefined,
  store: AgoraObserverStore
): AgoraObserverRole | null {
  if (!room) {
    return null;
  }
  if (room.userRole === MediaUserRole.host) {
    return 'host';
  }
  const isRecorder =
    store.rootGetters['getCurrentUser']?.event_role === UserRole.RECORDER_BOT ||
    store.rootState.route?.query?.record_mode === 'true';
  return isRecorder ? 'recorder' : null;
}
